/* eslint-disable react-hooks/exhaustive-deps,import/no-unresolved */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import { CardDetails } from 'assets/components';
import { CardState } from '../constants';
import useIsUsUser from '../../../utilities/sharedHooks/usUser';
import { CardPlaceholder } from '../../../components/Placeholders';

const Card = ({
  amount = 0,
  currency = '',
  cardStatus = null,
  flip,
  openCardSettingModal,
  cardProvider = null,
  toggelPendingCardInfo,
  loading = false,
  openCardCurrencyNote,
}) => {
  const amountRef = useRef();
  const [currencyXCoordinate, setCurrencyXCoordinate] = useState(-100);
  const isUsUser = useIsUsUser();
  const displayedCardCurrency =
    cardStatus?.cardCurrency?.toUpperCase() || cardStatus?.currency?.toUpperCase();

  const calculatePositions = () => {
    if (amountRef.current) {
      setCurrencyXCoordinate(25 + amountRef.current.getComputedTextLength());
    }
  };

  useEffect(() => {
    setTimeout(calculatePositions, 500);
  }, [amount, currency]);

  const handleFlipAction = () => {
    if (
      (cardStatus &&
        [CardState.ACTIVE, CardState.ACTIVATION].includes(cardStatus?.cardState?.toUpperCase())) ||
      isUsUser
    ) {
      flip();
    }
  };

  const renderCardState = useMemo(() => {
    if (loading) {
      return <CardPlaceholder />;
    }

    return (
      <CardDetails
        cardStatus={cardStatus}
        cardProvider={cardProvider}
        openCardSettingModal={openCardSettingModal}
        flip={flip}
        handleFlipAction={handleFlipAction}
        amount={amount}
        toggelPendingCardInfo={toggelPendingCardInfo}
        currency={currency}
        openCardCurrencyNote={openCardCurrencyNote}
      />
    );
  }, [
    cardStatus,
    cardStatus?.cardState,
    amount,
    currencyXCoordinate,
    cardProvider,
    displayedCardCurrency,
    isMobile,
    loading,
  ]);

  return <>{renderCardState}</>;
};

export default Card;

Card.propTypes = {
  amount: PropTypes.string,
  currency: PropTypes.string,
  flip: PropTypes.func.isRequired,
  openCardSettingModal: PropTypes.func.isRequired,
  cardStatus: PropTypes.object,
  cardProvider: PropTypes.string,
  toggelPendingCardInfo: PropTypes.func.isRequired,
  openCardCurrencyNote: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};
